export const CALENDLY_FOREIGN_EVENT_PROVIDER = 'Calendly'

export const isCalendlyForeignEventProvider = (foreignEventProvider?: string | null): boolean => (
  foreignEventProvider?.toLowerCase() === CALENDLY_FOREIGN_EVENT_PROVIDER.toLowerCase()
)
